import React, {useEffect, useState} from "react"
import {Col, Row} from "react-bootstrap";
import dayjs from "dayjs";
import {PillarsService} from "../../../../../services/pillars-api.service";
import GratitudeViewSkeleton from "../../../../skeletons/home/GratitudeViewSkeleton";
import Heading from "../../../../../components/dashboard/heading-component/Heading";
import ArchiveCard from "../../../../../components/dashboard/cards/archive-card/ArchiveCard";
import {DropDownCheck, SFilterIcon} from "../../../../../../assets/icons/defaultIcons";
import {Dropdown} from "antd";
import NoRecord from "../../../../../components/dashboard/no-record/NoRecord";

export default function Archive() {
    const [addGratitude ,setAddGratitude] = useState(false);
    const [archiveData, setArchiveData] = useState([])
    const [getListing, setGetListing] = useState(false)
    const [loader, setLoader] = useState(true)
    const [selectedItem, setSelectedItem] = useState('All');

    async function GetArchiveData(filterType=40,selected='All') {
        setSelectedItem(selected)
        let endDate = dayjs().format('YYYY-MM-DD');
        let startDate = ''

        switch (filterType) {
            case 10:

                startDate = dayjs().subtract(1, 'week').toISOString();
                endDate = dayjs().toISOString();
                break
            case 20:

                startDate = dayjs().subtract(1, 'month').toISOString();
                endDate = dayjs().toISOString();
                break
            case 30:

                startDate = dayjs().subtract(3, 'month').toISOString();
                endDate = dayjs().toISOString();
                break
            default:
                endDate = '';
                startDate = '';
                break
        }

        setLoader(true)
        const response = await PillarsService.getArchivePillars(startDate,endDate)
        if (response.data?.data?.data){
            setArchiveData(response.data.data.data)
            setLoader(false)
        }
    }

    useEffect(()=>{
        GetArchiveData()
    }, [getListing])

    if (loader) {
        return <GratitudeViewSkeleton/>
    }


    const items = [
        {
            key: '1',
            label: (
                <a onClick={()=>{GetArchiveData(40, 'All')}} className={'d-flex justify-content-between w-100'}>
                    All {selectedItem === 'All' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
        {
            key: '2',
            label: (
                <a onClick={()=>{GetArchiveData(10, 'Weekly')}} className={'d-flex justify-content-between w-100'}>
                    Weekly {selectedItem === 'Weekly' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
        {
            key: '3',
            label: (
                <a onClick={()=>{GetArchiveData(20, 'Monthly')}} className={'d-flex justify-content-between w-100'}>
                    Monthly {selectedItem === 'Monthly' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
        {
            key: '4',
            label: (
                <a onClick={()=>{GetArchiveData(30, 'Quaterly')}} className={'d-flex justify-content-between w-100'}>
                    Quaterly {selectedItem === 'Quaterly' &&  <span><DropDownCheck/></span> }
                </a>
            ),
        },
    ];

    return(
        <div className={'gratitude gratitude-listing'}>
            <div className={'gratitude-sub-heading-sec'}>
                <div className={'d-flex align-items-center gap-2'}>
                    <Heading heading={'Archives'} back={true}/>
                    <p className={'mb-4'}>({archiveData.length})</p>
                </div>

                <div className={'mb-4'}>
                   <Dropdown menu={{ items }} placement="bottomLeft" trigger={'click'} loading={loader} onClick={(e)=>console.log("onclick event", e)}>
                       <span className={'theme-dropdown-1'}><SFilterIcon/>  {selectedItem ? selectedItem : ''}</span>
                   </Dropdown>
               </div>
            </div>
            <Row>
                {
                    archiveData.map((item,index)=>{
                        return(
                            <Col className={'mb-4'} sm={12} md={6} xl={6} xxl={4} key={index}>
                                <ArchiveCard modalHeading={item.question} getListing={getListing} setGetListing={setGetListing} heading={item.content[0].label} id={item._id} des={item.content[0].text} date={dayjs(item.createdAt).format('DD-MM-YYYY')}/>
                            </Col>
                        )
                    })
                }
                {
                    archiveData.length <= 0 &&
                    <NoRecord/>
                }
            </Row>

        </div>
    )
}